import {AbstractControl} from '@angular/forms';
export class PasswordValidation {

    static MatchPassword(AC: AbstractControl) {
       let password = AC.get('senha').value; // to get value in input tag
       let confirmPassword = AC.get('confirmaSenha').value; // to get value in input tag
        if(password != confirmPassword) {
            AC.get('confirmaSenha').setErrors( {MatchPassword: true} )
        } else {
            return null
        }
    }
}
